import { render, staticRenderFns } from "./App.vue?vue&type=template&id=50775e97"
var script = {}
import style0 from "./assets/styles/common/common.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports